import React from 'react'

import { Card } from '@telavita-core/react-design-kit'

import { PatientEligibility } from 'components/PatientEligibility/PatientEligibility'

export const CreditsCard = ({
  isEnterprise,
  isCorporate,
  isCareplus,
  isCassi,
  isCapitation,
  showRequestTreatment,
  hasButton,
  setHasButton,
  planGroupName,
  creditsStatus,
  availableCredits,
  maxCredits,
  enableDetails,
  validDate,
  expired,
  errorButton,
  loadingButton,
  solicitationDate,
  isUnlimited,
  startDate,
  corporateEligibility,
  loading,
  onClickRequestCreditsButton,
  forceUpdate,
  psychiatryEligibility,
  psychiatryEligibilityLoading,
  onForceUpdate,
  cardNumber,
  onRequestTreatement,
  planGroupCode,
  patientPlans,
  reasonCode,
  handleUpdateSelectedPlan,
  planName,
  showFullPlanName,
  planCode,
  showPlanSwitch,
  showPsychiatry,
  creditsPanelErrorMessage,
  username,
  patientSelectedPlan = null
}) => {
  const isEnabled = isCorporate || isEnterprise

  if (!isEnabled)
    return null
  
  return (
    <Card customClassName='PatientHome__Card PatientHome__Eligibility'>
      <PatientEligibility 
        patientPlans={patientPlans}
        isEnterprise={isEnterprise}
        isCorporate={isCorporate}
        isCareplus={isCareplus}
        isCassi={isCassi}
        isCapitation={isCapitation}
        showRequestTreatment={showRequestTreatment}
        hasButton={hasButton}
        setHasButton={setHasButton}
        planGroupName={planGroupName}
        creditsStatus={creditsStatus}
        availableCredits={availableCredits}
        maxCredits={maxCredits}
        enableDetails={enableDetails}
        validDate={validDate}
        expired={expired}
        errorButton={errorButton}
        loadingButton={loadingButton}
        solicitationDate={solicitationDate}
        isUnlimited={isUnlimited}
        startDate={startDate}
        onClickRequestCreditsButton={onClickRequestCreditsButton}
        corporateEligibility={corporateEligibility}
        loading={loading}
        forceUpdate={forceUpdate}
        psychiatryEligibility={psychiatryEligibility}
        psychiatryEligibilityLoading={psychiatryEligibilityLoading}
        onForceUpdate={onForceUpdate}
        onRequestTreatement={onRequestTreatement}
        cardNumber={cardNumber}
        planGroupCode={planGroupCode}
        reasonCode={reasonCode}
        handleUpdateSelectedPlan={handleUpdateSelectedPlan}
        planName={planName}
        showFullPlanName={showFullPlanName}
        showPlanSwitch={showPlanSwitch}
        planCode={planCode}
        showPsychiatry={showPsychiatry}
        creditsPanelErrorMessage={creditsPanelErrorMessage}
        username={username}
        patientSelectedPlan={patientSelectedPlan}
      />
    </Card >
  )
}
